import { Flex } from 'antd';
import { Text } from '../Ant';
import NotificationCard from './notificationCard';
import dayjs from 'dayjs';
import { getNotificationIcon } from '../../helpers/notification';
import { IGroupedNotifications, IInAppNotification } from '../../interface';
import { getLocalDateAndTime } from '../../constants/utilityFunctions';

interface NotificationContentProps {
  groupedNotifications: IGroupedNotifications[];
  language: string;
  onNotificationClick: (notification: IInAppNotification) => void;
  loadMoreRef?: (node?: Element | null) => void;
  hasNextPage?: boolean;
}

const NotificationContent: React.FC<NotificationContentProps> = ({
  groupedNotifications,
  language,
  onNotificationClick,
  loadMoreRef,
  hasNextPage,
}) => {
  return (
    <>
      {groupedNotifications?.length > 0 &&
        groupedNotifications.map((item) => (
          <Flex
            gap={10}
            vertical
            key={item?.date + item?.notifications.length}
            data-testid={`notification-group-${item?.date}`}
          >
            <Text
              $fontsize="13px"
              $lineheight="18px"
              $color="primary"
              $weight={600}
              data-testid="notification-date"
            >
              {getLocalDateAndTime(new Date(item?.date), true)}
            </Text>
            {item?.notifications.map((notification) => {
              const title = notification?.title[language];
              const content = notification?.content[language];
              return (
                <NotificationCard
                  key={notification?.readAt + notification?.id}
                  icon={getNotificationIcon(notification?.template?.identifier)}
                  title={title}
                  description={content}
                  time={dayjs(
                    notification?.data?.notificationDateTime ?? notification?.createdAt,
                  ).format('HH:mm')}
                  isHighPriority={!notification?.readAt}
                  onClick={() => onNotificationClick(notification)}
                  data-testid={`notification-card-${notification?.id}`}
                />
              );
            })}
          </Flex>
        ))}
      {hasNextPage && <div ref={loadMoreRef} data-testid="loading-indicator" />}
    </>
  );
};

export default NotificationContent;
